import React, { FC } from "react";
import { useSelector } from "react-redux";

import { Button, Input, Modal } from "../../../components/common";
import { useUpdateInvoiceForm } from "../../../hooks/useUpdateInvoiceForm";
import { selectInvoice } from "../../../store/reducers/invoice";
import { Controller } from "react-hook-form";

type Props = {
  isOpen: boolean;
  close: () => void;
};

export const EditInvoiceNumberFormModal: FC<Props> = ({ isOpen, close }) => {
  const invoice = useSelector(selectInvoice);
  const { control } = useUpdateInvoiceForm(invoice);

  return (
    <Modal isOpen={isOpen} close={close} title="Edit invoice number">
      <form className="flex flex-col gap-8">
        <Controller
          name="number"
          control={control}
          render={({ field }) => (
            <Input type="string" maxLength="10" {...field} prefix="#" />
          )}
        />

        <Button
          variant={Button.variant.PRIMARY}
          className="w-full"
          onClick={close}
        >
          Close
        </Button>
      </form>
    </Modal>
  );
};
